export default {
  labels: {
    reply: 'Odpowiedź właściciela',
  },
  form: {
    reply_text: {
      placeholder: 'Wpisz swoją odpowiedź...',
    },
  },
  buttons: {
    generate_reply: 'Generuj odpowiedź',
    submit_reply: 'Wyślij odpowiedź',
  },
  toasts: {
    failed_to_create_reply: 'Nie udało się utworzyć odpowiedzi',
    failed_to_generate_ai_reply: 'Nie udało się wygenerować odpowiedzi AI',
  },
};
